<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Free Listing</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <free-listing-form :data="data"></free-listing-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import FreeListingForm from './FreeListingForm'
import { axios } from '../../../utils'
import FormErrors from '../../../components/FormErrors'
export default {
  name: 'FreeListingDialog',
  data() {
    return {
      data: {
        id: null,
        business_name: '',
        category: '',
        suburb: '',
        address: '',
        description: '',
        telephone: '',
        mobile: '',
        website: '',
        email: '',
        active: false,
        verified: false
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'free_listings', 'item'],
  components: {
    FreeListingForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting free_listings data for id ', this.item.id)
      axios
        .get('api/admin/free-listings/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new free_listings')
      axios
        .post('api/admin/free-listings/create', {
          ...this.data
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating free_listings data for id ', this.item.id)
      axios
        .put(`api/admin/free-listings/${this.item.id}`, {
          ...this.data
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        id: null,
        business_name: '',
        category: '',
        suburb: '',
        address: '',
        description: '',
        telephone: '',
        mobile: '',
        website: '',
        email: '',
        active: false,
        verified: false
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
